import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";


// fetch pending payout
const fetchReserveTrans = async ({ page, limit, search }) => {
  const response = await api.get("/v1/admin/personal/reserve-transactions", {
    params: { page, limit, ...(search && { search }) },
  });
  return response.data;
};

export const useReserveTrans = (page = 1, limit = 10, search = "") => {
  return useQuery({
    queryKey: ["reserve-trans", page, limit, search],
    queryFn: () => fetchReserveTrans({ page, limit, search }),
    refetchOnWindowFocus: false,
  });
};

// approve reserve transaction
const approveReserveTrans = async (uuid) => {
  const { data } = await api.post(
    `/v1/admin/personal/reserve/${uuid}/approve`
  );
  return data;
};

export const useApproveReserveTrans = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveReserveTrans,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reserve-trans"] });
    },
  });
};

// extend reserve transaction (payload: {"days": number })
const extendReserveTrans = async (uuid, payload) => {
  const { data } = await api.post(
    `/v1/admin/personal/reserve/${uuid}/extend`,
    payload
  );
  return data;
};

// ─── Hook ───
export const useExtendReserveTrans = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ uuid, payload }) => 
      extendReserveTrans(uuid, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reserve-trans"] });
    },
  });
};

// cancel reserve transaction  (payload: {"reason": string })
const cancelReserveTransaction = async (uuid, payload) => {
  const { data } = await api.post(
    `/v1/admin/personal/reserve/${uuid}/cancel`,
    payload
  );
  return data;
};

export const useCancelReserveTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn:({ uuid , payload }) => cancelReserveTransaction(uuid, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reserve-trans"] });
    },
  });
};